function _extends() {
  _extends = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i]
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key]
            }
          }
        }
        return target
      }
  return _extends.apply(this, arguments)
}

import React from 'react'
/** @jsxRuntime classic */

/** @jsx jsx */

import { jsx } from '@emotion/core'
export const SvgIcon = /*#__PURE__*/ React.forwardRef(
  ({ children, ...props }, ref) => {
    return jsx(
      'svg',
      _extends(
        {
          css: {
            color: 'white',
            overflow: 'visible',
          },
          fill: 'none',
        },
        props,
        {
          ref: ref,
        }
      ),
      children
    )
  }
)
SvgIcon.displayName = 'SvgIcon'
export default function svgToIcon({ paths, name, ...rest }) {
  const Icon = (props, ref) =>
    jsx(
      SvgIcon,
      _extends(
        {
          ref: ref,
        },
        rest,
        props
      ),
      paths
    )

  Icon.displayName = name
  return /*#__PURE__*/ React.memo(/*#__PURE__*/ React.forwardRef(Icon))
}
